import {
  footerServiceLinks,
  footerContentLinks,
  footerCompanyLinks,
  serviceAreas,
} from '@/mocks/homeContent';
import LineIcon from '@/components/base/LineIcon';

export default function Footer() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-md bg-primary-500 flex items-center justify-center">
                <span className="w-6 h-6 flex items-center justify-center text-background-50 text-xl">
                  <i className="ri-truck-line" />
                </span>
              </div>
              <div className="leading-tight">
                <div className="font-bold text-lg text-background-50 whitespace-nowrap">
                  吉川産業
                </div>
                <div className="text-xs text-background-100/70 tracking-wide whitespace-nowrap">
                  運営:吉川産業
                </div>
              </div>
            </div>
            <p className="text-background-100/80 text-sm leading-relaxed mb-5">
              京都府全域を対応エリアとする、不用品回収・遺品整理・古紙回収・資源回収・産廃収集運搬・一般廃棄物回収・機密書類処分・骨董品買取の専門会社です。即日対応・丁寧作業・法人対応。
            </p>
            <div className="space-y-2 text-sm text-background-100/85">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-map-pin-line" />
                </span>
                京都府京都市左京区田中上玄京町53-1
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-phone-line" />
                </span>
                0120-219-620
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-time-line" />
                </span>
                9:00〜17:00 / 年中無休
              </p>
            </div>
            <a
              href="https://lin.ee/yKaHc4I"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-accent-700 hover:bg-accent-800 text-background-50 font-bold text-sm whitespace-nowrap cursor-pointer transition-colors"
            >
              <LineIcon className="w-[18px] h-[18px] shrink-0" />
              LINEで無料見積り
            </a>
          </div>

          {/* Links columns */}
          <div className="lg:col-span-5 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
                サービス
              </h4>
              <ul className="space-y-2.5">
                {footerServiceLinks.map((link) => (
                  <li key={link}>
                    <a
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo('#services');
                      }}
                      rel="nofollow"
                      className="text-background-100/75 hover:text-primary-300 text-sm whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
                コンテンツ
              </h4>
              <ul className="space-y-2.5">
                {footerContentLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo(link.href);
                      }}
                      rel="nofollow"
                      className="text-background-100/75 hover:text-primary-300 text-sm whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
                会社情報
              </h4>
              <ul className="space-y-2.5">
                {footerCompanyLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo(link.href);
                      }}
                      rel="nofollow"
                      className="text-background-100/75 hover:text-primary-300 text-sm whitespace-nowrap cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Service areas */}
          <div className="lg:col-span-3">
            <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
              対応エリア(京都府)
            </h4>
            <div className="flex flex-wrap gap-1.5">
              {serviceAreas.map((area) => (
                <span
                  key={area}
                  className="px-2.5 py-1 rounded-full bg-secondary-800 text-background-100/80 text-[11px] whitespace-nowrap"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© 2026 吉川産業 All rights reserved.</p>
          <p className="tracking-wider">
            京都 不用品回収 / 京都 遺品整理 / 古紙回収 / 産廃収集運搬
          </p>
        </div>
      </div>
    </footer>
  );
}